module.exports = __webpack_public_path__ + "img/HH-article.6fb864f4.jpg";